import PropTypes from "prop-types";
import React from "react";
import { NumberField } from "cxa-form-field";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";

const HourMinuteType = ({ question }) =>
  <div>
    {question.tag === "physical_activity_hours_sleeping" &&
      <img
        src="/assets/images/wellness/physical_activity_hours_sleeping_img.png"
        alt="sleeping hours"
      />}

    {question.tag === "physical_activity_hours_driving" &&
      <img
        src="/assets/images/wellness/physical_activity_hours_driving_img.png"
        alt="driving hours"
      />}

    {question.tag === "physical_activity_hours_at_work" &&
      <img
        src="/assets/images/wellness/physical_activity_hours_at_work_img.png"
        alt="working hours"
      />}

    {question.tag === "physical_activity_hours_ideal_work" &&
      <img
        src="/assets/images/wellness/physical_activity_hours_ideal_work_img.png"
        alt="ideal work"
      />}

    <p>
      <FormattedMessage
        id={question.questionText}
        defaultMessage={question.questionText}
      />
    </p>
    <div className="field">
      <NumberField
        name={`question_${question.tag}`}
        max="24"
        step="1"
        min="0"
      />
      <p>
        <FormattedMessage {...messages.hoursDescription} />
      </p>
    </div>
    <div className="field">
      <NumberField name={`${question.tag}_minutes`} max="60" step="1" min="0" />
      <p>
        <FormattedMessage {...messages.minutesDescription} />
      </p>
    </div>
  </div>;

HourMinuteType.propTypes = { question: PropTypes.object };

export default HourMinuteType;



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/questionnaire/display-types/hour-minute.jsx